<app-light-bottom-svg></app-light-bottom-svg>
<div class="container-fluid bg-gray text-light">
  <div class="row text-center pt-5 animate-to-top">
    <div class="col-12">
      <h1 class="horizontal-line">
        <span class="bg-gray px-3">Some Of My Works</span>
      </h1>
    </div>
  </div>
  <div class="row mt-5 animate-to-top">
    <div *ngFor="let work of workList" class="col-12 col-md-6 col-lg-4">
      <div class="card my-3 bg-dark-black position-relative w-100">
        <img
          class="card-img-top h-100 p-4"
          src="{{ work.bannerImage }}"
          alt="Card image cap"
        />
        <div class="card-body bg-dark-black position-absolute w-100">
          <div class="row">
            <div class="col-6">
              <p class="mb-0"><b>Developed In</b></p>
              <p class="mb-0">{{ work.developedLanguage }}</p>
            </div>
            <div class="col-6">
              <a
                href="{{ work.navigationUrl }}"
                class="float-right text-light mb-5 bg-transparent text-light shadow-none border rounded-0 h-auto btn"
                target="_blank"
                >Take a look</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
